import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { ServiceProductModel } from '@models/types'

interface ServiceProductProps {
  callbacks?: {
    onClick: () => void,
  },
  entity: ServiceProductModel,
  selected: boolean,
}

const ServiceProduct = (props: ServiceProductProps) => {
  const {
    callbacks,
    entity: { id, title },
    selected,
  } = props

  const { onClick } = callbacks || {}

  return (
    <DashboardModuleListItem
      isChecked={selected}
      onClick={onClick}
      showCheckbox
      title={title}
    >
      <Text color="bodyFontLightColor">ID #{id}</Text>
    </DashboardModuleListItem>
  )
}

export default ServiceProduct
